<template>
  <td>{{ formattedDate }}</td>
</template>

<script>
  import utils from '../../../../utils';
  export default {
    name: "TableDateLabel",
    props: ['timestamp'],
    computed: {
      formattedDate() {
        return utils.formatUnixTimestamp(this.timestamp);
      }
    }
  }
</script>

<style scoped>
  td {
    text-align: center;
  }
</style>
